import { computed, inject, Injectable, signal } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { SessionTopicAssignmentBySession } from '../../../../interfaces';
import { AppService, BaseAreaService, FuncService } from "../../../../services";


@Injectable({
	providedIn: 'root'
})
export class AccSessionViewerDialogDataService {

	private app = inject(AppService);
	private func = inject(FuncService);
	private dialogService = inject(DialogService);
	private util = inject(UtilityService);
	accSessionDetails = signal<SessionTopicAssignmentBySession | undefined>(undefined);
	baseAreaService = signal<BaseAreaService | undefined>(undefined);

	isReadonly = computed(() => !this.app.data().permissions.canCoordinateVolunteers);

	public async getAccSessionData(accSessionId: number, topicId: number) {
		const response = await this.func.volunteering.specialistSignUp.getSessionTopic({ accSessionId, topicId });
		console.log(accSessionId, { response });
		if (response) this.accSessionDetails.set(response);
	}


	public async reloadData() {
		const accSessionDetails = this.accSessionDetails();
		if (!accSessionDetails) return;

		return this.getAccSessionData(accSessionDetails.accSessionId, accSessionDetails.topicId);
	}


	public async assignSpecialist(volunteerSignupSpecialistTopicId: number, canAttendConflict: boolean) {
		const accSessionDetails = this.accSessionDetails();
		if (!accSessionDetails) return;

		if (await this.checkIfSurveysExist(accSessionDetails.countOfSurveys)) return;

		if (canAttendConflict) {
			await this.dialogService.showMessage('Message', `This specialist has already been assigned to another session. Please review their existing sign ups. The ability to assign a specialist to multiple events doesn't exist yet.`);
			return;
		}

		await this.func.volunteering.specialistSignUp.assignSpecialistToTopic({
			accSessionId: accSessionDetails.accSessionId,
			topicId: accSessionDetails.topicId,
			volunteerSignupSpecialistTopicId,
		});

		await this.reloadData();

	}


	public async changeToStatus(volunteerSignupSpecialistTopicId: number, setToStatus: 'Pending' | 'Waitlisted' | 'Removed') {
		const accSessionDetails = this.accSessionDetails();
		if (!accSessionDetails) return;

		if (await this.checkIfSurveysExist(accSessionDetails.countOfSurveys)) return;

		await this.func.volunteering.specialistSignUp.setVolunteerSpecialistSignupStatus({
			accSessionId: accSessionDetails.accSessionId,
			topicId: accSessionDetails.topicId,
			volunteerSignupSpecialistTopicId,
			setToStatus,
		});
		await this.reloadData();
	}


	private async checkIfSurveysExist(countOfSurveys: number) {
		if (countOfSurveys > 0) {
			await this.dialogService.showMessage('Message', `Cannot make changes as this session has ${this.util.text.singularOrPluralWithCount(countOfSurveys, 'survey', 'surveys')} associated with it.`, 'Okay', [], 300, 200);
			return true;
		}

		return false;
	}

}